var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('textarea',{attrs:{"placeholder":_vm.placeholder,"id":"summernote"},domProps:{"value":_vm.$attrs.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }